import { Component, Inject, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

declare const $: any;

import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-stripe-pay-dialog',
    templateUrl: './stripe-pay-dialog.component.html',
    styleUrls: ['./stripe-pay-dialog.component.scss'],
    standalone: false
})
export class StripePayDialogComponent implements AfterViewInit {
	requiereAVS;
	constructor(
		public appService: AppService,
		public dialogRef: MatDialogRef<StripePayDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.requiereAVS = this.data.account.paymentVerificationStrategy == "fullAddress";
	}

	ngAfterViewInit(): void {
		setTimeout(() => { this.initStripe() }, 1600);
	}

	initStripe() {
		let that = this;
		const accountId = this.data.account.providerAccountId
		const stripe = window['Stripe'](this.appService.appConfig.stripeClientKey, { stripeAccount: accountId });
		document.querySelector("#payment-form").addEventListener("submit", handleSubmit);
		const elements = stripe.elements({
			appearance: { theme: 'stripe' },
			clientSecret: this.data.secret
		});
		const paymentElement = elements.create("payment");
		paymentElement.mount("#payment-element");

		if (this.requiereAVS) {
			const addressElement = elements.create('address', { mode: 'billing' });
			addressElement.mount('#stripe-address-element');
		}

		function handleSubmit(e) {
			e.preventDefault();
			setLoading(true);
			stripe.confirmPayment({
				elements,
				confirmParams: {},
				redirect: "if_required"
			}).then(res => {
				let error = res.error;
				if (error) {
					if (error.type === "card_error" || error.type === "validation_error") {
						setLoading();
						$('#stripe-payment-message').html(error.message).removeClass('hidden');
					} else {
						that.dialogRef.close({ mode: "error" });
					}
				} else {
					that.dialogRef.close({ mode: "success", transactionId: res.paymentIntent.id  });
				}					
			}).catch(err => {
				that.dialogRef.close({ mode: "error" });
			})
		}

		setTimeout(() => { setLoading() }, 1000);
		function setLoading(show?) {
			if (show) {
				$('#stripe-payment-message').addClass('hidden');
				$("#stripe-submit").removeClass('mat-mdc-button-disabled').prop('disabled', true);
				$('app-stripe-pay-dialog ._load-animate').addClass('_load-active');
			} else {
				$("#stripe-submit").removeClass('mat-mdc-button-disabled').prop('disabled', false);
				$('app-stripe-pay-dialog ._load-animate').removeClass('_load-active');
			}
		}
	}
}
